import { ChangeDetectorRef, Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, Subject, distinctUntilChanged, map, shareReplay, takeUntil, tap } from 'rxjs';
import { MediaChange } from '@angular/flex-layout';
import { MediaObserverService } from './media-observer.service';

@Injectable()
export class ComponentMediaObserverService extends Subject<void> implements OnDestroy {
  private readonly mediaObserver = inject(MediaObserverService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    super();
  }

  hasBreakpoint(mq: string): Observable<boolean> {
    return this.mediaObserver.asObservable().pipe(
      map(changes => changes?.[mq]),
      map(Boolean),
      distinctUntilChanged(),
      tap(() => this.changeDetectorRef.markForCheck()),
      shareReplay({ refCount: true, bufferSize: 1 }),
      takeUntil(this)
    );
  }

  changes(...mqs: string[]): Observable<MediaChange[]> {
    return this.mediaObserver.asObservable().pipe(
      map(changes =>
        mqs.reduce((acc: MediaChange[], mq) => {
          if (changes?.[mq]) {
            acc.push(changes?.[mq]);
          }
          return acc;
        }, [])
      ),
      distinctUntilChanged(),
      tap(() => this.changeDetectorRef.markForCheck()),
      shareReplay({ refCount: true, bufferSize: 1 }),
      takeUntil(this)
    );
  }

  ngOnDestroy(): void {
    this.next();
    this.complete();
  }
}
